import DrawerListItem from './DrawerListItem/DrawerListItem';

export function getAvailableRoutes(routes, user, onClick) {
    return routes.reduce((availableRoutes, { text, path, Icon, allowedRoles, heading }) => {
        if (!checkIsAllowed(user, allowedRoles)) return availableRoutes;

        const isDesksPage = path === '/all-desks';
        const listItemAttributes = isDesksPage ? { href: path } : { href: path, target: '_blank', rel: 'noopener noreferrer' };

        const routeItem = (
            <DrawerListItem
                key={text}
                listItemComponent="a"
                listItemAttributes={listItemAttributes}
                onClick={onClick}
                text={text}
                Icon={Icon}
                route={path}
                heading={heading}
            />
        );
        availableRoutes.push(routeItem);
        return availableRoutes;
    }, []);
}

function checkIsAllowed(user, allowedRoles) {
    if (!allowedRoles) return true;
    let allowedAccess = false;
    if (user) {
        allowedAccess = allowedRoles.reduce((allowedAccess, allowedRole) => {
            !allowedAccess && user.roles.includes(allowedRole) && (allowedAccess = true);
            return allowedAccess;
        }, false);
    }

    return allowedAccess;
}
